import { render, staticRenderFns } from "./BirdDogBonusItem.vue?vue&type=template&id=6ac7b138&scoped=true&"
import script from "./BirdDogBonusItem.vue?vue&type=script&lang=js&"
export * from "./BirdDogBonusItem.vue?vue&type=script&lang=js&"
import style0 from "./BirdDogBonusItem.vue?vue&type=style&index=0&id=6ac7b138&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac7b138",
  null
  
)

export default component.exports